/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_ClockStation_ChannelsStateModel } from '../models/BigClock_Api_Models_ClockStation_ChannelsStateModel';
import type { BigClock_Api_Models_ClockStation_ChannelTimeModel } from '../models/BigClock_Api_Models_ClockStation_ChannelTimeModel';
import type { BigClock_Api_Models_ClockStation_ImpulseModel } from '../models/BigClock_Api_Models_ClockStation_ImpulseModel';
import type { BigClock_Api_Models_ClockStation_SetAstronomicRelayCoordinatesModel } from '../models/BigClock_Api_Models_ClockStation_SetAstronomicRelayCoordinatesModel';
import type { BigClock_Api_Models_ClockStation_SetAstronomicRelaySourceModel } from '../models/BigClock_Api_Models_ClockStation_SetAstronomicRelaySourceModel';
import type { BigClock_Api_Models_ClockStation_SetChimesVolumeModel } from '../models/BigClock_Api_Models_ClockStation_SetChimesVolumeModel';
import type { BigClock_Api_Models_ClockStation_SetRelayModeModel } from '../models/BigClock_Api_Models_ClockStation_SetRelayModeModel';
import type { BigClock_Api_Models_ClockStation_SetRelayTimeScheduleModel } from '../models/BigClock_Api_Models_ClockStation_SetRelayTimeScheduleModel';
import type { BigClock_Api_Models_ClockStation_UpdateClockSystemSerialNumberModel } from '../models/BigClock_Api_Models_ClockStation_UpdateClockSystemSerialNumberModel';
import type { BigClock_Api_Models_ClockStation_UpdateSerialNumberModel } from '../models/BigClock_Api_Models_ClockStation_UpdateSerialNumberModel';
import type { BigClock_Api_Models_StandardTimeModel } from '../models/BigClock_Api_Models_StandardTimeModel';
import type { BigClock_Api_Models_StandardTimeOffsetModel } from '../models/BigClock_Api_Models_StandardTimeOffsetModel';
import type { BigClock_Api_Models_UpdateClockStationRelayDescriptionModel } from '../models/BigClock_Api_Models_UpdateClockStationRelayDescriptionModel';
import type { BigClock_Api_Models_UpdateDeviceRequest } from '../models/BigClock_Api_Models_UpdateDeviceRequest';
import type { BigClock_Application_Models_ClockStation_WarrantyDto } from '../models/BigClock_Application_Models_ClockStation_WarrantyDto';
import type { BigClock_Application_Models_ClockStationBlocksDto } from '../models/BigClock_Application_Models_ClockStationBlocksDto';
import type { BigClock_Application_Queries_Common_OldClockStationDto } from '../models/BigClock_Application_Queries_Common_OldClockStationDto';
import type { BigClock_Application_Queries_GetAstronomicRelayConfig_GetAstronomicRelayConfigResponse } from '../models/BigClock_Application_Queries_GetAstronomicRelayConfig_GetAstronomicRelayConfigResponse';
import type { BigClock_Application_Queries_GetClockStationChannelsImpulse_GetClockStationChannelsImpulseResponse } from '../models/BigClock_Application_Queries_GetClockStationChannelsImpulse_GetClockStationChannelsImpulseResponse';
import type { BigClock_Application_Queries_GetClockStationParameters_GetClockStationParametersResponse } from '../models/BigClock_Application_Queries_GetClockStationParameters_GetClockStationParametersResponse';
import type { BigClock_Application_Queries_GetClockStationRelayInfo_GetClockStationRelayInfoResponse } from '../models/BigClock_Application_Queries_GetClockStationRelayInfo_GetClockStationRelayInfoResponse';
import type { BigClock_Application_Queries_GetClockStationRelayStatus_GetClockStationRelayStatusResponse } from '../models/BigClock_Application_Queries_GetClockStationRelayStatus_GetClockStationRelayStatusResponse';
import type { BigClock_Application_Queries_GetClockStationTime_GetClockStationTimeResponse } from '../models/BigClock_Application_Queries_GetClockStationTime_GetClockStationTimeResponse';
import type { BigClock_Application_Queries_GetClockStationWarranty_GetClockStationWarrantyResponse } from '../models/BigClock_Application_Queries_GetClockStationWarranty_GetClockStationWarrantyResponse';
import type { BigClock_Application_Queries_GetDuskDawnTime_GetDuskDawnTimeResponse } from '../models/BigClock_Application_Queries_GetDuskDawnTime_GetDuskDawnTimeResponse';
import type { BigClock_Application_Queries_GetRelayTimeSchedule_GetRelayTimeScheduleResponse } from '../models/BigClock_Application_Queries_GetRelayTimeSchedule_GetRelayTimeScheduleResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClockStationService {
    /**
     * @deprecated
     * @returns BigClock_Application_Queries_Common_OldClockStationDto Success
     * @throws ApiError
     */
    public static getApiClockStation(): CancelablePromise<Array<BigClock_Application_Queries_Common_OldClockStationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static putApiClockStation(
        requestBody?: BigClock_Api_Models_UpdateDeviceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ClockStation',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiClockStation1(
        clockStationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @deprecated
     * @param clockStationId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiClockStationParameters(
        clockStationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/parameters',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetClockStationParameters_GetClockStationParametersResponse Success
     * @throws ApiError
     */
    public static getApiClockStationParams(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockStationParameters_GetClockStationParametersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/params',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiClockStationSerialNumber(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_UpdateSerialNumberModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ClockStation/{clockStationId}/serial-number',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiClockStationClockSystemSerialNumber(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_UpdateClockSystemSerialNumberModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ClockStation/{clockStationId}/clock-system-serial-number',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetClockStationTime_GetClockStationTimeResponse Success
     * @throws ApiError
     */
    public static getApiClockStationTime(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockStationTime_GetClockStationTimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/time',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClockStationTime(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_StandardTimeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/time',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiClockStationTimeTimezone(
        clockStationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/time/timezone',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClockStationTimeTimezone(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_StandardTimeOffsetModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/time/timezone',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @deprecated
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetClockStationChannelsImpulse_GetClockStationChannelsImpulseResponse Success
     * @throws ApiError
     */
    public static getApiClockStationChannelsImpulse(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockStationChannelsImpulse_GetClockStationChannelsImpulseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/channels/impulse',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClockStationChannelsImpulse(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_ImpulseModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/channels/impulse',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClockStationChannelsState(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_ChannelsStateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/channels/state',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClockStationChannelsArrows(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_ChannelTimeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/channels/arrows',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetClockStationRelayInfo_GetClockStationRelayInfoResponse Success
     * @throws ApiError
     */
    public static getApiClockStationRelay(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockStationRelayInfo_GetClockStationRelayInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/relay',
            path: {
                'clockStationId': clockStationId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiClockStationRelayDescription(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_UpdateClockStationRelayDescriptionModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ClockStation/{clockStationId}/relay/description',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClockStationRelayMode(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_SetRelayModeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/relay/mode',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetClockStationRelayStatus_GetClockStationRelayStatusResponse Success
     * @throws ApiError
     */
    public static getApiClockStationRelayStatus(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockStationRelayStatus_GetClockStationRelayStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/relay/status',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetRelayTimeSchedule_GetRelayTimeScheduleResponse Success
     * @throws ApiError
     */
    public static getApiClockStationRelayScheduler(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetRelayTimeSchedule_GetRelayTimeScheduleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/relay/scheduler',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiClockStationRelayScheduler(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_SetRelayTimeScheduleModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/relay/scheduler',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetDuskDawnTime_GetDuskDawnTimeResponse Success
     * @throws ApiError
     */
    public static getApiClockStationRelayDuskDawn(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDuskDawnTime_GetDuskDawnTimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/relay/dusk-dawn',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetAstronomicRelayConfig_GetAstronomicRelayConfigResponse Success
     * @throws ApiError
     */
    public static getApiClockStationGpsCoordinates(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetAstronomicRelayConfig_GetAstronomicRelayConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/gps/coordinates',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiClockStationGpsCoordinates(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_SetAstronomicRelayCoordinatesModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/gps/coordinates',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiClockStationGpsCoordinatesSource(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_SetAstronomicRelaySourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/gps/coordinates/source',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiClockStationChimesVolume(
        clockStationId: string,
        requestBody?: BigClock_Api_Models_ClockStation_SetChimesVolumeModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/chimes/volume',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns void
     * @throws ApiError
     */
    public static postApiClockStationChimesTest(
        clockStationId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/chimes/test',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @returns void
     * @throws ApiError
     */
    public static postApiClockStationMelodyTest(
        clockStationId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/melody/test',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Models_ClockStationBlocksDto Success
     * @throws ApiError
     */
    public static getApiClockStationBlocks(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Models_ClockStationBlocksDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/blocks',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiClockStationBlocks(
        clockStationId: string,
        requestBody?: BigClock_Application_Models_ClockStationBlocksDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/blocks',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockStationId
     * @returns BigClock_Application_Queries_GetClockStationWarranty_GetClockStationWarrantyResponse Success
     * @throws ApiError
     */
    public static getApiClockStationWarranty(
        clockStationId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockStationWarranty_GetClockStationWarrantyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ClockStation/{clockStationId}/warranty',
            path: {
                'clockStationId': clockStationId,
            },
        });
    }
    /**
     * @param clockStationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiClockStationWarranty(
        clockStationId: string,
        requestBody?: BigClock_Application_Models_ClockStation_WarrantyDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ClockStation/{clockStationId}/warranty',
            path: {
                'clockStationId': clockStationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
